import React from 'react';
import IconButton from '../IconButton/IconButton';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const renderIcon = (type) => {
  switch (type) {
    case 'email':
      return <MailOutlineIcon />;
    case 'edit':
      return <EditOutlinedIcon />;
    case 'delete':
      return <DeleteOutlinedIcon />;
    default:
      break;
  }
};

const DataGridBulkEditButton = ({ onClick, type, tooltip, ...props }) => {
  return (
    <IconButton
      onClick={onClick}
      tooltip={tooltip ?? 'Edit selected'}
      {...props}
    >
      {renderIcon(type ?? 'edit')}
    </IconButton>
  );
};

export default DataGridBulkEditButton;
